import {
    RequestConfigFunction, SelectorConfig,
} from 'app/types/request.types'

import {
    LongTermLeaseSelectorType,
    ModificationRequiredContainersType,
} from 'app/Apps/OrderManagement/LongTermLease/longTermLease.types'

type LongTermLeaseRequests = {
    create: RequestConfigFunction<{data: any}>,
    update: RequestConfigFunction<{longTermLeaseId: number, data: any}>,
    get: RequestConfigFunction<{id: number}>,
    updateStatus: RequestConfigFunction<{id: number, action: string}>,
    modifyRequiredContainers: RequestConfigFunction<{
        longTermLeaseId: number,
        data: Partial<ModificationRequiredContainersType>,
    }>,
    requiredContainersChange: RequestConfigFunction<number>,
    rejectedContainerChange: RequestConfigFunction<number>,
    selector: ({
        includeFilters,
    }
    ?: {
        includeFilters: Record<string, any>,
    }) => SelectorConfig<LongTermLeaseSelectorType[]>,
    modifications: RequestConfigFunction<{id: number}>,
}

const longTermLeaseRequests: LongTermLeaseRequests = {
    create: ({
        data,
    }) => {
        return {
            url: 'longtermlease',
            method: 'POST',
            data,
        }
    },
    update: ({
        longTermLeaseId,
        data,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}`,
            method: 'PATCH',
            data,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `longtermlease/${id}`,
            method: 'GET',
        }
    },
    updateStatus: ({
        id,
        action,
    }) => {
        return {
            url: `longtermlease/${id}/status/${action}`,
            method: 'PATCH',
        }
    },
    modifyRequiredContainers: ({
        longTermLeaseId,
        data,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/requiredcontainers`,
            method: 'PATCH',
            data,
        }
    },
    requiredContainersChange: (longTermLeaseId) => {
        return {
            url: `longtermlease/${longTermLeaseId}/requiredcontainers/changes`,
            method: 'GET',
        }
    },
    rejectedContainerChange: (longTermLeaseId) => {
        return {
            url: `longtermlease/${longTermLeaseId}/rejectedcontainer/filter-request/all`,
            method: 'POST',
        }
    },
    selector: ({
        includeFilters,
    }) => {
        return {
            url: 'longtermlease/filter-request/selector',
            method: 'POST',
            data: {
                includeFilters,
            },
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `longtermlease/${id}/modifications`,
            method: 'GET',
        }
    },
}

export default longTermLeaseRequests
